import { useQuery } from "@tanstack/react-query";
import { createFileRoute } from "@tanstack/react-router";
import { SearchX } from "lucide-react";

import { ButtonRouter } from "~/components/ui/button";
import { Card } from "~/components/ui/card";
import { EmptyState } from "~/components/ui/empty-state";
import { adminStoryQueryOptions } from "~/lib/functions/transformation-story";

import { StoryReview } from "./-components/story-review";

export const Route = createFileRoute("/admin/cih/stories/$storyId")({
  staticData: { title: "Review Story" },
  loader: async ({ context, params }) => {
    const story = await context.queryClient.ensureQueryData(
      adminStoryQueryOptions(params.storyId),
    );
    return { title: story?.name ?? "Story not found" };
  },
  component: StoryReviewPage,
});

function StoryReviewPage(): React.ReactElement {
  const { storyId } = Route.useParams();
  const { data: story } = useQuery(adminStoryQueryOptions(storyId));

  if (!story) {
    return (
      <Card className="p-0">
        <EmptyState
          icon={SearchX}
          title="Story not found"
          description="It may have been deleted."
        >
          <ButtonRouter to="/admin/cih/stories" variant="default" size="sm">
            Back to success stories
          </ButtonRouter>
        </EmptyState>
      </Card>
    );
  }

  // Keyed on the id only: a refetch after saving text must not reset review
  // choices the admin has made but not yet submitted, such as outcome verified.
  return <StoryReview key={story.id} story={story} />;
}
